import segment from 'src/js/modules/analytics/segment';
import settingIds from '../constants/setting-ids';

const {
  constants,
  trackers: { trackEvent },
} = segment;

const trackMediaTypeChanged = ({
  tabId,
  oldMediaType,
  newMediaType,
  blockId,
  blockVariationId,
}) => {
  if (!blockId || !blockVariationId) return;

  trackEvent(constants.events.ELEMENT_SETTINGS_MEDIA_TYPE_CHANGED, {
    blockId,
    blockVariationId,
    settingId: settingIds.THIS_MEDIA,
    tabId,
    oldElementId: oldMediaType,
    newElementId: newMediaType,
  });
};

export default trackMediaTypeChanged;
